import { render, staticRenderFns } from "./SideBySide.vue?vue&type=template&id=43ed34a8&scoped=true&"
import script from "./SideBySide.vue?vue&type=script&lang=js&"
export * from "./SideBySide.vue?vue&type=script&lang=js&"
import style0 from "./SideBySide.vue?vue&type=style&index=0&id=43ed34a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ed34a8",
  null
  
)

export default component.exports